import { useTranslation } from '@kostbar/i18n'
import { useEdges } from '../hooks/use-edges'
import { EdgeStatusBadge } from './edge-status-badge'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table'
import { Badge } from '@/components/ui/badge'
import { Skeleton } from '@/components/ui/skeleton'
import { formatRelativeTime } from '@/shared/utils/format-date'
import { ResponsiveTableWrapper } from '@/shared/components/responsive-table-wrapper'

export function EdgesTable() {
  const { t: tEdges } = useTranslation('edges')
  const { t: tCommon } = useTranslation('common')
  const { data, isLoading, error } = useEdges()

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
      </div>
    )
  }

  if (error) {
    return (
      <p className="text-sm text-muted-foreground">
        {tEdges('errors.loadFailed')}
      </p>
    )
  }

  const edges = data?.items || []

  if (edges.length === 0) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        <p>{tEdges('table.emptyTitle')}</p>
        <p className="text-sm mt-2">{tEdges('table.emptyDescription')}</p>
      </div>
    )
  }

  return (
    <ResponsiveTableWrapper>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>{tEdges('table.edgeId')}</TableHead>
            <TableHead>{tEdges('table.edgeName')}</TableHead>
            <TableHead>{tEdges('table.restaurant')}</TableHead>
            <TableHead>{tEdges('table.status')}</TableHead>
            <TableHead>{tEdges('table.lastSeen')}</TableHead>
            <TableHead>{tEdges('table.bundleVersion')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {edges.map((edge) => (
            <TableRow key={edge.id}>
              <TableCell className="font-mono text-sm">{edge.id}</TableCell>
              <TableCell className="text-sm">
                {edge.fingerprint || '—'}
              </TableCell>
              <TableCell>
                {edge.restaurantName ||
                  tEdges('table.restaurantFallback', {
                    id: edge.restaurantId,
                  })}
              </TableCell>
              <TableCell>
                <EdgeStatusBadge
                  online={edge.online}
                  lastSeen={edge.lastSeen}
                />
              </TableCell>
              <TableCell className="text-sm text-muted-foreground">
                {edge.lastSeen ? formatRelativeTime(edge.lastSeen) : '—'}
              </TableCell>
              <TableCell>
                {edge.appliedBundleVersion !== null ? (
                  <Badge variant="secondary">
                    {tCommon('versionPrefix')}
                    {edge.appliedBundleVersion}
                  </Badge>
                ) : (
                  <span className="text-muted-foreground text-sm">—</span>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </ResponsiveTableWrapper>
  )
}
